var map = {
	"./account.svg": 23387,
	"./adjust.svg": 21183,
	"./alarm.svg": 53457,
	"./album.svg": 95575,
	"./alert.svg": 25644,
	"./anchor.svg": 19421,
	"./android.svg": 17911,
	"./animation.svg": 32716,
	"./antenna.svg": 89283,
	"./api.svg": 96422,
	"./apps.svg": 98894,
	"./assistant.svg": 6486,
	"./at.svg": 76537,
	"./atm.svg": 39966,
	"./attachment.svg": 17193,
	"./atv.svg": 37445,
	"./autorenew.svg": 8990,
	"./baby.svg": 53414,
	"./backspace.svg": 46823,
	"./balcony.svg": 47414,
	"./ballot.svg": 22300,
	"./bandage.svg": 60204,
	"./bank.svg": 77256,
	"./barrel.svg": 92946,
	"./basket.svg": 516,
	"./basketball.svg": 14211,
	"./bathtub.svg": 91290,
	"./battery.svg": 43637,
	"./bed.svg": 55455,
	"./bee.svg": 1166,
	"./bell.svg": 38657,
	"./biathlon.svg": 6125,
	"./bike.svg": 88305,
	"./blender.svg": 84858,
	"./blur.svg": 35837,
	"./book.svg": 61073,
	"./bookmark.svg": 61826,
	"./boombox.svg": 70446,
	"./briefcase.svg": 66142,
	"./broadcast.svg": 2699,
	"./brush.svg": 95098,
	"./bug.svg": 23900,
	"./bullhorn.svg": 56174,
	"./bus.svg": 8672,
	"./cached.svg": 65704,
	"./cake.svg": 150,
	"./calendar.svg": 16576,
	"./camera.svg": 12775,
	"./cancel.svg": 89300,
	"./candle.svg": 54401,
	"./car.svg": 60576,
	"./carabiner.svg": 10517,
	"./cart.svg": 82748,
	"./cast.svg": 50975,
	"./cellphone.svg": 76226,
	"./charity.svg": 80734,
	"./check.svg": 3370,
	"./checkbook.svg": 94241,
	"./church.svg": 21911,
	"./city.svg": 20563,
	"./clock.svg": 70032,
	"./close.svg": 76806,
	"./cloud.svg": 57881,
	"./coffee.svg": 92110,
	"./cog.svg": 84775,
	"./cogs.svg": 63830,
	"./collage.svg": 42857,
	"./compare.svg": 26783,
	"./compass.svg": 69614,
	"./compost.svg": 61531,
	"./contacts.svg": 43989,
	"./controller.svg": 50618,
	"./cookie.svg": 9796,
	"./copyright.svg": 24325,
	"./countertop.svg": 76563,
	"./cradle.svg": 15599,
	"./creation.svg": 25213,
	"./cricket.svg": 91907,
	"./crop.svg": 49168,
	"./crosshairs.svg": 97549,
	"./crowd.svg": 30241,
	"./delete.svg": 53955,
	"./delta.svg": 7576,
	"./details.svg": 22276,
	"./devices.svg": 33859,
	"./dialpad.svg": 99711,
	"./directions.svg": 40496,
	"./dishwasher.svg": 74138,
	"./diving.svg": 25637,
	"./dns.svg": 36963,
	"./domain.svg": 77726,
	"./download.svg": 88162,
	"./dumbbell.svg": 58109,
	"./earth.svg": 14438,
	"./eject.svg": 69017,
	"./email.svg": 74278,
	"./emoticon.svg": 8074,
	"./equalizer.svg": 13510,
	"./eye.svg": 45733,
	"./fax.svg": 43139,
	"./fencing.svg": 98816,
	"./ferry.svg": 50150,
	"./file.svg": 50904,
	"./film.svg": 87904,
	"./filmstrip.svg": 46978,
	"./finance.svg": 83888,
	"./fingerprint.svg": 91338,
	"./fire.svg": 72958,
	"./firebase.svg": 67981,
	"./flag.svg": 4912,
	"./flare.svg": 66282,
	"./flash.svg": 34220,
	"./flower.svg": 33079,
	"./folder.svg": 89674,
	"./food.svg": 39466,
	"./football.svg": 29309,
	"./forest.svg": 14533,
	"./forum.svg": 26437,
	"./forward.svg": 87841,
	"./fullscreen.svg": 37097,
	"./gamepad.svg": 4387,
	"./gauge.svg": 81199,
	"./gesture.svg": 87883,
	"./gmail.svg": 64180,
	"./golf.svg": 37182,
	"./google.svg": 53231,
	"./grain.svg": 90779,
	"./grass.svg": 94572,
	"./grid.svg": 90370,
	"./grill.svg": 22994,
	"./gymnastics.svg": 2988,
	"./hail.svg": 23860,
	"./hammer.svg": 32928,
	"./handball.svg": 12098,
	"./hdr.svg": 22464,
	"./headphones.svg": 71103,
	"./headset.svg": 22680,
	"./heart.svg": 8454,
	"./hiking.svg": 22494,
	"./history.svg": 37650,
	"./home.svg": 40651,
	"./hub.svg": 24239,
	"./human.svg": 4013,
	"./hvac.svg": 48108,
	"./image.svg": 81297,
	"./inbox.svg": 66090,
	"./information.svg": 76384,
	"./iron.svg": 72208,
	"./kabaddi.svg": 91426,
	"./karate.svg": 17688,
	"./kayaking.svg": 40229,
	"./key.svg": 20479,
	"./keyboard.svg": 30313,
	"./kite.svg": 34351,
	"./kitesurfing.svg": 69221,
	"./label.svg": 7316,
	"./ladybug.svg": 31244,
	"./landslide.svg": 25728,
	"./laptop.svg": 80410,
	"./launch.svg": 10803,
	"./layers.svg": 67072,
	"./leak.svg": 95299,
	"./library.svg": 24427,
	"./license.svg": 37195,
	"./lightbulb.svg": 53851,
	"./link.svg": 20914,
	"./liquor.svg": 90766,
	"./lock.svg": 55763,
	"./login.svg": 6313,
	"./logout.svg": 41944,
	"./looks.svg": 35502,
	"./loupe.svg": 33387,
	"./magnify.svg": 24283,
	"./map.svg": 96248,
	"./marker.svg": 62756,
	"./medication.svg": 13119,
	"./meditation.svg": 36082,
	"./memory.svg": 40723,
	"./menu.svg": 44011,
	"./merge.svg": 20746,
	"./message.svg": 33591,
	"./microphone.svg": 91414,
	"./minus.svg": 41142,
	"./monitor.svg": 28896,
	"./moped.svg": 10485,
	"./more.svg": 41805,
	"./mosque.svg": 25732,
	"./motion.svg": 10668,
	"./motorbike.svg": 60398,
	"./mouse.svg": 35231,
	"./movie.svg": 2730,
	"./mustache.svg": 86192,
	"./nature.svg": 1347,
	"./navigation.svg": 73012,
	"./newspaper.svg": 77775,
	"./noodles.svg": 49010,
	"./opacity.svg": 48885,
	"./overscan.svg": 33679,
	"./palette.svg": 66067,
	"./panorama.svg": 15943,
	"./paperclip.svg": 82386,
	"./paragliding.svg": 38494,
	"./parking.svg": 81334,
	"./pasta.svg": 29263,
	"./pause.svg": 56632,
	"./pencil.svg": 77817,
	"./phone.svg": 9578,
	"./piano.svg": 66485,
	"./pin.svg": 34063,
	"./pinwheel.svg": 87404,
	"./pizza.svg": 39528,
	"./play.svg": 33616,
	"./plus.svg": 92478,
	"./podcast.svg": 95006,
	"./polo.svg": 99502,
	"./post.svg": 53392,
	"./power.svg": 38557,
	"./printer.svg": 10046,
	"./publish.svg": 31143,
	"./puzzle.svg": 30606,
	"./racquetball.svg": 69550,
	"./radar.svg": 31954,
	"./radio.svg": 12207,
	"./raw.svg": 61912,
	"./redo.svg": 85898,
	"./refresh.svg": 68863,
	"./reminder.svg": 70640,
	"./remote.svg": 48364,
	"./rename.svg": 33464,
	"./repeat.svg": 75259,
	"./replay.svg": 53827,
	"./reply.svg": 13950,
	"./restart.svg": 57467,
	"./restore.svg": 46572,
	"./rewind.svg": 75583,
	"./ribbon.svg": 29230,
	"./rocket.svg": 34130,
	"./rodent.svg": 52428,
	"./rowing.svg": 71946,
	"./rss.svg": 15118,
	"./rugby.svg": 25507,
	"./run.svg": 44645,
	"./satellite.svg": 46461,
	"./saxophone.svg": 6747,
	"./scanner.svg": 17940,
	"./school.svg": 10966,
	"./scooter.svg": 86207,
	"./sd.svg": 53667,
	"./seat.svg": 34129,
	"./security.svg": 36784,
	"./segment.svg": 96725,
	"./send.svg": 98212,
	"./shape.svg": 42521,
	"./share.svg": 56364,
	"./shopping.svg": 62422,
	"./shuffle.svg": 57653,
	"./sigma.svg": 5991,
	"./silverware.svg": 67042,
	"./sim.svg": 2191,
	"./skate.svg": 42924,
	"./skateboard.svg": 94708,
	"./skateboarding.svg": 72804,
	"./ski.svg": 73301,
	"./sledding.svg": 39044,
	"./sleep.svg": 90427,
	"./smoking.svg": 3264,
	"./snowboard.svg": 95885,
	"./snowflake.svg": 88394,
	"./snowmobile.svg": 17281,
	"./snowshoeing.svg": 99038,
	"./soccer.svg": 94171,
	"./spa.svg": 7404,
	"./speaker.svg": 27309,
	"./spellcheck.svg": 43328,
	"./stadium.svg": 93867,
	"./star.svg": 57290,
	"./steering.svg": 71663,
	"./stop.svg": 25394,
	"./store.svg": 79293,
	"./subtitles.svg": 71993,
	"./subway.svg": 16217,
	"./surfing.svg": 12254,
	"./synagogue.svg": 83580,
	"./sync.svg": 54487,
	"./tab.svg": 73719,
	"./tablet.svg": 78606,
	"./tag.svg": 73690,
	"./taxi.svg": 91662,
	"./tea.svg": 47104,
	"./television.svg": 11018,
	"./tennis.svg": 12707,
	"./terrain.svg": 69293,
	"./text.svg": 13271,
	"./texture.svg": 21755,
	"./thermostat.svg": 20997,
	"./ticket.svg": 87062,
	"./timelapse.svg": 10452,
	"./toolbox.svg": 67787,
	"./train.svg": 5380,
	"./tram.svg": 81394,
	"./transition.svg": 26591,
	"./translate.svg": 2540,
	"./truck.svg": 89419,
	"./tsunami.svg": 3819,
	"./tune.svg": 41304,
	"./undo.svg": 93708,
	"./update.svg": 88661,
	"./upload.svg": 47409,
	"./usb.svg": 32908,
	"./vacuum.svg": 74299,
	"./vibrate.svg": 2259,
	"./video.svg": 13559,
	"./violin.svg": 18117,
	"./voicemail.svg": 61605,
	"./volcano.svg": 76656,
	"./volleyball.svg": 76874,
	"./vote.svg": 56382,
	"./walk.svg": 35893,
	"./wallet.svg": 21293,
	"./wallpaper.svg": 14400,
	"./watch.svg": 36311,
	"./water.svg": 91971,
	"./watermark.svg": 73980,
	"./web.svg": 95000,
	"./widgets.svg": 17889,
	"./wrench.svg": 18317,
	"./youtube.svg": 13249
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(id => {
		return __webpack_require__.t(id, 1 | 16);;
	});
}
function webpackAsyncContextResolve(req) {
	return __webpack_require__.e(/* lazy-once context | material-icons */ "material-icons").then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 55452;
module.exports = webpackAsyncContext;